import { Button, Checkbox, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, mergeClasses, Spinner, Text } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useCommonStyles, useStores } from '../../../common/hooks';
import { ExcelFieldInfo } from '../../../models';
import './ExportNominationFieldsModal.scss';

const additionalFields: ExcelFieldInfo[] = [
  {
    displayName: 'Abstract',
    typeCode: 'ABSTRACT'
  },
  {
    displayName: 'Executive Summary',
    typeCode: 'EXECUTIVESUMMARY'
  },
  {
    displayName: 'Qualifications',
    typeCode: 'QUALIFICATIONS'
  },
  {
    displayName: 'Partner Type',
    typeCode: 'PARTNERTYPE'
  },
  {
    displayName: 'Link to Nomination',
    typeCode: 'LINKTONOMINATION'
  },
];

const noneWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
];

const awardNominationWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Last Edited',
    typeCode: 'LASTEDITED'
  },
  {
    displayName: 'Alias',
    typeCode: 'ALIAS'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
];

const awardScrubbingWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
];

const awardJudgingWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Assigned to',
    typeCode: 'ASSIGNEDTO'
  },
  {
    displayName: 'Assigned since',
    typeCode: 'ASSIGNEDSINCE'
  },
  {
    displayName: 'Judged',
    typeCode: 'JUDGED'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
];

const awardReviewDesignateWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Designation',
    typeCode: 'DESIGNATION'
  },
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
  {
    displayName: 'Score',
    typeCode: 'SCORE'
  },
];

const awardWinnersWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Designation',
    typeCode: 'DESIGNATION'
  },
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Score',
    typeCode: 'SCORE'
  },
  {
    displayName: 'Questionnaire',
    typeCode: 'QUESTIONNAIRE'
  },
  {
    displayName: 'Last Edited',
    typeCode: 'LASTEDITED'
  },
];

const countryAwardNominationWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Last Edited',
    typeCode: 'LASTEDITED'
  },
  {
    displayName: 'Alias',
    typeCode: 'ALIAS'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
  {
    displayName: 'Category Awards Nominations',
    typeCode: 'CATEGORY'
  }
];

const countryAwardScrubbingWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Status',
    typeCode: 'STATUS'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Category Awards Nominations',
    typeCode: 'CATEGORY'
  }
];

const countryAwardWinnersWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Designation',
    typeCode: 'DESIGNATION'
  },
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
  {
    displayName: 'Questionnaire',
    typeCode: 'QUESTIONNAIRE'
  },
  {
    displayName: 'Last Edited',
    typeCode: 'LASTEDITED'
  },
  {
    displayName: 'Category Awards Nominations',
    typeCode: 'CATEGORY'
  }
];

const countryAwardReviewDesignateWindowFields: ExcelFieldInfo[] = [
  {
    displayName: 'Designation',
    typeCode: 'DESIGNATION'
  },
  {
    displayName: 'Nomination Number',
    typeCode: 'NOMINATIONNUMBER'
  },
  {
    displayName: 'Nomination Name',
    typeCode: 'NOMINATIONNAME'
  },
  {
    displayName: 'Company',
    typeCode: 'COMPANY'
  },
  {
    displayName: 'Country',
    typeCode: 'LOCATION'
  },
  {
    displayName: 'Category Awards Nominations',
    typeCode: 'CATEGORY'
  }
];

interface ExportNominationFieldsModalProps {
  isModalOpen: boolean;
  isDownloading: boolean;
  isCountryAward: boolean;
  onCancelButtonClicked(): void;
  onExportButtonClicked(selectedFields: string[]): void;
}

const ExportNominationFieldsModalImpl: React.FC<ExportNominationFieldsModalProps> = (props) => {
  const {
    isModalOpen,
    isDownloading,
    isCountryAward,
    onCancelButtonClicked,
    onExportButtonClicked,
  } = props;

  const commonStyles = useCommonStyles();

  const {
    awardStore,
  } = useStores();

  const [selectedFields, setSelectedFields] = useState<string[]>([]);

  const checkboxChecked = (typeCode: string): boolean => {
    return selectedFields.some((selectedField) => selectedField === typeCode);
  };

  const onCheckField = (typeCode: string, checked: boolean): void => {
    if (checked) {
      setSelectedFields([...selectedFields, typeCode]);
    } else {
      const index = selectedFields.indexOf(typeCode);
      if (index > -1) {
        const selectedFieldsToRemove = [...selectedFields];
        selectedFieldsToRemove.splice(index, 1);
        setSelectedFields(selectedFieldsToRemove);
      }
    }
  };

  const getFields = (): ExcelFieldInfo[] => {
    if (awardStore.isNominationWindowOpen) {
      return [...(isCountryAward ? countryAwardNominationWindowFields : awardNominationWindowFields), ...additionalFields];
    }

    if (awardStore.isScrubbingWindowOpen) {
      return [...(isCountryAward ? countryAwardScrubbingWindowFields : awardScrubbingWindowFields), ...additionalFields];
    }

    if (isCountryAward == false && awardStore.isJudgingWindowOpen) {
      return [...awardJudgingWindowFields, ...additionalFields];
    }

    if (awardStore.isReviewAndDesignateWindowOpen || awardStore.isComplianceAndRevisionsWindowOpen) {
      return [...(isCountryAward ? countryAwardReviewDesignateWindowFields : awardReviewDesignateWindowFields), ...additionalFields];
    }

    if (awardStore.isWinnersWindowOpen) {
      return [...(isCountryAward ? countryAwardWinnersWindowFields : awardWinnersWindowFields), ...additionalFields];
    }

    return noneWindowFields;
  }

  const getTypeCodes = (fields: ExcelFieldInfo[]): string[] => {
    return fields.map((field) => field.typeCode);
  }

  const preloadData = (): void => {
    const noneFields = getTypeCodes(noneWindowFields);
    setSelectedFields(noneFields);

    if (awardStore.isNominationWindowOpen) {
      const awardFields = getTypeCodes(awardNominationWindowFields);
      const countryFields = getTypeCodes(countryAwardNominationWindowFields);
      const fields = isCountryAward ? countryFields : awardFields;
      setSelectedFields([...fields, ...getTypeCodes(additionalFields)]);
      return;
    }

    if (awardStore.isScrubbingWindowOpen) {
      const awardFields = getTypeCodes(awardScrubbingWindowFields);
      const countryFields = getTypeCodes(countryAwardScrubbingWindowFields);
      const fields = isCountryAward ? countryFields : awardFields;
      setSelectedFields([...fields, ...getTypeCodes(additionalFields)]);
      return;
    }

    if (isCountryAward == false && awardStore.isJudgingWindowOpen) {
      const awardFields = getTypeCodes(awardJudgingWindowFields);
      const fields = awardFields;
      setSelectedFields([...fields, ...getTypeCodes(additionalFields)]);
      return;
    }

    if (awardStore.isReviewAndDesignateWindowOpen || awardStore.isComplianceAndRevisionsWindowOpen) {
      const awardFields = getTypeCodes(awardReviewDesignateWindowFields);
      const countryFields = getTypeCodes(countryAwardReviewDesignateWindowFields);
      const fields = isCountryAward ? countryFields : awardFields;
      setSelectedFields([...fields, ...getTypeCodes(additionalFields)]);
      return;
    }

    if (awardStore.isWinnersWindowOpen) {
      const awardFields = getTypeCodes(awardWinnersWindowFields);
      const countryFields = getTypeCodes(countryAwardWinnersWindowFields);
      const fields = isCountryAward ? countryFields : awardFields;
      setSelectedFields([...fields, ...getTypeCodes(additionalFields)]);
      return;
    }
  }

  useEffect(() => {
    preloadData();
  }, []);

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open && !isDownloading) onCancelButtonClicked();
      }}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, 'export-nomination-fields-modal')}
      >
        <DialogBody
          className={commonStyles.modalBody}
        >
          <DialogTitle
            action={
              <Button
                appearance='subtle'
                aria-label='close'
                icon={<Dismiss24Regular />}
                onClick={() => onCancelButtonClicked()}
              />
            }
          >
            Export nomination
          </DialogTitle>
          <DialogContent>
            <Text 
              weight='semibold'
            >
              Exported fields
            </Text>
            <div className='export-fields-list'>
              {
                getFields().map((field) => (
                  <Checkbox
                    key={field.typeCode}
                    label={field.displayName}
                    checked={checkboxChecked(field.typeCode)}
                    onChange={(_, data) => onCheckField(field.typeCode, !!data.checked)}
                  />
                ))
              }
            </div>
          </DialogContent>
          <DialogActions>
            {
              (selectedFields.length === 0) &&
              <Text 
                className='text-status-error'
              >
                Please select at least one field.
              </Text>
            }
            <Button
              appearance='secondary'
              onClick={() => onCancelButtonClicked()}
            >
              Cancel
            </Button>
            <Button
              appearance='primary'
              onClick={() => onExportButtonClicked(selectedFields)}
              disabled={selectedFields.length === 0 || isDownloading}
              icon={isDownloading ? <Spinner size='tiny' /> : undefined}
            >
              Export
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const ExportNominationFieldsModal = observer(ExportNominationFieldsModalImpl);
